import { FC } from 'react';
import ConsentBox from './ConsentBox/ConsentBox';
import { ConsentType } from './types';
import MessageFactory from './MessageFactory/MessageFactory';

interface IUserConsentProps {
    consentBoxProps: {
        hasConsented: boolean;
        handleClick: (e: Event) => void;
        className?: string;
    };
    messageFactoryProps: {
        type: ConsentType;
        messageProps?: any;
    };
}

const UserConsent: FC<IUserConsentProps> = ({ consentBoxProps, messageFactoryProps }) => {
    const Message = (
        <MessageFactory type={messageFactoryProps.type} messageComponentProps={messageFactoryProps?.messageProps} />
    );

    return <ConsentBox {...consentBoxProps} Message={Message} />;
};

export default UserConsent;
